export default __webpack_public_path__ + "static/media/Summary.0ec350ec.svg";